import { Box } from '@mui/material';
import { Spinner } from 'components/core';
import React, { useRef } from 'react';
import { useAuth0 } from 'services/auth0/react-auth0.spa';

/**
 * Returns the first non-loading value of `isAuthenticated` and keeps it stable
 * for the rest of the component lifecycle. This prevents the download views
 * from flicker-remounting when Auth0 briefly re-enters its loading state after
 * the initial resolution.
 */
export function useResolvedIsAuthenticated(): boolean | undefined {
  const { isAuthenticated, loading: auth0ClientLoading } = useAuth0();
  const resolvedRef = useRef<boolean | undefined>(undefined);

  if (!auth0ClientLoading && resolvedRef.current === undefined) {
    resolvedRef.current = isAuthenticated;
  }

  return resolvedRef.current;
}

/** The spinner of the public download links, which work without the service worker. */
export function FullScreenSpinner({
  reason,
}: {
  reason: string;
}): React.ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      <Spinner position='static' reason={reason} withServiceWorkerDiagnostics={false} />
    </Box>
  );
}
